import { render, staticRenderFns } from "./companyAuth.vue?vue&type=template&id=2cefdcbe&scoped=true"
import script from "./companyAuth.vue?vue&type=script&lang=js"
export * from "./companyAuth.vue?vue&type=script&lang=js"
import style0 from "./companyAuth.vue?vue&type=style&index=0&id=2cefdcbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cefdcbe",
  null
  
)

export default component.exports